import { render, staticRenderFns } from "./LegacyModal.vue?vue&type=template&id=2a1f4e88&scoped=true"
import script from "./LegacyModal.vue?vue&type=script&lang=js"
export * from "./LegacyModal.vue?vue&type=script&lang=js"
import style0 from "./LegacyModal.vue?vue&type=style&index=0&id=2a1f4e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f4e88",
  null
  
)

export default component.exports